import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'tt-report-preview-dialog',
    templateUrl: './report-preview-dialog.component.html',
    styleUrls: ['./report-preview-dialog.component.css'],
})
export class ReportPreviewDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: ReportPreviewDialogData, dialogRef: MatDialogRef<ReportPreviewDialogComponent>) {
        dialogRef.updateSize('80vw', '90vh');
    }
}

export interface ReportPreviewDialogData {
    heading: string;
    p2_reportdef_keyno: `${number}` | number;
    report_type_keyno: `${number}` | number;
    parameters: { [key: string]: string };
}
